// Partner data for the home page

export const homePartners = [
  {
    name: "Watoto",
    logo: "/Logo-03.png",
  },
  {
    name: "Pesapal",
    logo: "/Logo-14.png",
  },
  {
    name: "Uganda Tourism Board",
    logo: "/Logo-09.png",
  },
  {
    name: "Association of tour operators",
    logo: "/Logo-08.png",
  },
  {
    name: "APTA",
    logo: "/Logo-07.png",
  },
  {
    name: "UWA",
    logo: "/Logo-01.png",
  },
  {
    name: "Belva Assocciates",
    logo: "/Logo-04.png",
  },
  {
    name: "Ministry of tourism",
    logo: "/Logo-02.png",
  },
  {
    name: "Skills Klinic",
    logo: "/Logo-10.png",
  },
  {
    name: "BNI Uganda",
    logo: "/Logo-05.png",
  },
  {
    name: "Explore Uganda",
    logo: "/Logo-12.png",
  },
  {
    name: "Safari Booking",
    logo: "/Logo-11.png",
  },
  {
    name: "Travel to marketing",
    logo: "/Logo-06.png",
  },
];

// Partner data for the booking page - using different images
export const bookingPartners = [
  {
    name: "Kenya Airways",
    logo: "/attached_assets/image_1741943444868.png",
  },
  {
    name: "Rwanda Air",
    logo: "/attached_assets/image_1741943447041.png",
  },
  {
    name: "Uganda Airlines",
    logo: "/attached_assets/image_1742235369483.png",
  },
  {
    name: "Emirates",
    logo: "/attached_assets/op.png",
  },
  {
    name: "Turkish Airlines",
    logo: "/attached_assets/image_1742807492619.png",
  },
  {
    name: "KLM",
    logo: "/attached_assets/netherlands.png",
  },
  {
    name: "Qatar Airways",
    logo: "/attached_assets/flag.png",
  },
  {
    name: "Air France",
    logo: "/attached_assets/france.png",
  },
  {
    name: "British Airways",
    logo: "/attached_assets/flag (1).png",
  },
  {
    name: "Lufthansa",
    logo: "/attached_assets/german.png",
  },
  {
    name: "China Southern",
    logo: "/attached_assets/china.png",
  },
];

// Payment options data
export const paymentOptions = [
  {
    name: "Visa",
    logo: "/visa.webp",
  },
  {
    name: "MTN Mobile Money",
    logo: "/mtn.jpg",
  },
  {
    name: "MasterCard",
    logo: "/mastercardlogo.png",
  },
  {
    name: "American Express",
    logo: "/amexlogo.png",
  },
  {
    name: "Airtel Money",
    logo: "/airtelmoney.webp",
  },
];